import { useEffect } from 'react'
import { RoleMoreModalHeader } from './RoleMoreModalHeader'
import { RoleMoreModalFormWrapper } from './RoleMoreModalFormWrapper'

const RoleMoreModal = () => {

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_user_role'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
        style={{ zIndex: 1057 }}
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-850px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <RoleMoreModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body'>
              <RoleMoreModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show' style={{ zIndex: 1056 }}></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export { RoleMoreModal }
